import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import placeHolderImage from '../../../../../assets/images/Placeholder-image.svg';
import ProductOverviewImages from './ProductOverviewImages';
import ProductOverviewInfo from './ProductOverviewInfo';

export default function ProductOverviewCard({ data, productCategoryList, shopId }) {
    const thumbImages = data?.images || [];
    const [thumbImg, setThumbImg] = useState(
        data?.default_image ? data.default_image : placeHolderImage
    );

    const handleThumbImage = (img) => {
        setThumbImg(img);
    };

    useEffect(() => {
        setThumbImg(data?.default_image ? data.default_image : placeHolderImage);
    }, [data.default_image]);

    return (
        <Card style={{ borderRadius: '16px' }} variant="outlined" className="pb-4">
            <Card.Body>
                <div className="row">
                    <div className="col-12 col-lg-5">
                        <ProductOverviewImages
                            thumbImg={thumbImg}
                            thumbImages={thumbImages}
                            handleThumbImage={handleThumbImage}
                        />
                    </div>
                    <div className="col-12 col-lg-7">
                        <ProductOverviewInfo
                            data={data}
                            productCategoryList={productCategoryList}
                            shopId={shopId}
                        />
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}
